import styled, { css, keyframes } from 'styled-components'
import type { LinkMenuProps } from './types'
import { BadgePosition } from '../../types'
import { darken } from 'polished'

const menuKeyframes = keyframes`
0% {
  opacity: 0;
}
57.1% {
  opacity: 0;
}
100% {
  opacity: 1;
}
`

const menuPosition = {
  default: () => css``
}
menuPosition[BadgePosition.TopLeft] = (height: number, margin: number) => css`
  left: ${margin}px;
  top: calc(${height}px + ${margin}px);
  border-radius: 0 0 10px 10px;
  z-index: 10;
`
menuPosition[BadgePosition.TopRight] = (height: number, margin: number) => css`
  right: ${margin}px;
  top: calc(${height}px + ${margin}px);
  border-radius: 0 0 10px 10px;
  z-index: 10;
`
menuPosition[BadgePosition.BottomLeft] = (
  height: number,
  margin: number
) => css`
  left: ${margin}px;
  bottom: calc(${height}px + ${margin}px);
  border-radius: 10px 10px 0 0;
`
menuPosition[BadgePosition.BottomRight] = (
  height: number,
  margin: number
) => css`
  right: ${margin}px;
  bottom: calc(${height}px + ${margin}px);
  border-radius: 10px 10px 0 0;
`

export const MenuBox = styled.div.attrs((props: LinkMenuProps) => props)`
  position: fixed;
  box-shadow: 0 8px 10px 0 rgba(0, 0, 0, 0.22);
  animation: ${menuKeyframes} 1.75s ease;
  background-color: ${({ descriptionBgColor }) => descriptionBgColor};
  line-height: 1.5;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  width: ${({ width }) => width}px;
  ${({ position, badgeHeight, badgeMargin }) =>
    menuPosition[position || 'default'](badgeHeight, badgeMargin)}
`

export const MenuDescription = styled.div.attrs(
  (props: LinkMenuProps) => props
)`
  margin: ${({ descriptionMargin }) => descriptionMargin}px;
  margin-bottom: 0px;
  font-size: ${({ descriptionFontSize }) => descriptionFontSize}px;
  color: ${({ descriptionFontColor }) => descriptionFontColor};
`

export const MenuLegend = styled.div.attrs((props: LinkMenuProps) => props)`
  margin: ${({ legendSpacing }) => legendSpacing}px
    ${({ descriptionMargin }) => descriptionMargin}px 4px;
  font-size: ${({ legendFontSize }) => legendFontSize}px;
  color: ${({ legendFontColor }) => legendFontColor};
  font-weight: ${({ legendFontWeight }) => legendFontWeight};
`

export const MenuItemList = styled.div.attrs((props: LinkMenuProps) => props)`
  background-color: ${({ itemBgColor }) => itemBgColor};
  font-size: ${({ itemFontSize }) => itemFontSize}px;
  ${({ position }) =>
    position === BadgePosition.TopLeft || position === BadgePosition.TopRight
      ? css`
          border-radius: 0 0 10px 10px;
        `
      : css``}
`

export const MenuItem = styled.a.attrs((props: LinkMenuProps) => props)`
  color: ${({ itemFontColor }) => itemFontColor};
  width: 100%;
  text-decoration: none;
  display: block;

  &:hover {
    background-color: ${({ itemBgColor = '' }) => darken(0.0628, itemBgColor)};
  }

  div {
    margin: 0 ${({ itemHorizontalMargin }) => itemHorizontalMargin}px;
    padding: ${({ itemVerticalMargin }) => itemVerticalMargin}px 0;
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid ${({ separatorColor }) => separatorColor};

    svg {
      width: 24px;
      height: 24px;

      line {
        stroke-width: 2px;
        stroke: ${({ itemGlyphColor }) => itemGlyphColor};
      }
    }
  }

  &:last-child > div {
    border-bottom: unset;
  }
`
